import { Box, Grid, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import GlobalButton from "../../../components/CustomButton";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import globalStyle from "../../../globalStyle";

const letters = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];
const newSectionObj = {
  strength: 0,
  section: "",
  subjects: [
    {
      name: "",
      teachBy: "",
      totalMarks: 0,
      passingMarks: 0,
      author: "",
    },
  ],
};

const AddSections = ({ classSections, setClassSections }) => {
  const handleAddNewSection = () => {
    let tempArray = [...classSections];
    tempArray.push(newSectionObj);
    setClassSections(tempArray);
  };

  const handleDeleteSection = (index) => {
    let tempArray = [...classSections];
    tempArray.splice(index, 1);
    setClassSections(tempArray);
  };

  const handleAddNewSubject = (mainIndex) => {
    const tempArray = JSON.parse(JSON.stringify(classSections));
    tempArray[mainIndex].subjects.push({
      name: "",
      teachBy: "",
      totalMarks: 0,
      passingMarks: 0,
      author: "",
    });
    setClassSections(tempArray);
  };

  return (
    <Stack mt={2} gap={2}>
      {classSections.map((val, mainIndex) => {
        return (
          <Box
            p={2}
            bgcolor={"primary.light"}
            borderRadius={1}
            position={"relative"}
          >
            {/* Cancel Button */}
            {mainIndex !== 0 && (
              <IconButton
                onClick={() => handleDeleteSection(mainIndex)}
                sx={{ position: "absolute", top: 5, right: 5 }}
              >
                <HighlightOffOutlinedIcon htmlColor="red" />
              </IconButton>
            )}
            <Typography mb={1} variant="h6" fontWeight={500}>
              Section {letters[mainIndex]}
            </Typography>
            <Box width={"30%"} mb={2}>
              <Label
                labelText="Strength"
                required
                htmlFor={`section_strength_main_${mainIndex}`}
              />
              <TextInput
                id={`section_strength_main_${mainIndex}`}
                required
                type={"text"}
                styleProps={globalStyle.textField}
                placeholder={"Enter section strength"}
              />
            </Box>
            {val.subjects.map((item, nestedIndex) => {
              return (
                <Grid container spacing={1.25} mb={1}>
                  <Grid item xs={12} sm={6} md={4}>
                    <Label labelText="Class Guardian/Class teacher" required />
                    <TextInput
                      styleProps={globalStyle.textField}
                      placeholder={"Enter class guradian/class teacher"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Label labelText={`Subject ${nestedIndex + 1}`} required />
                    <TextInput
                      styleProps={globalStyle.textField}
                      placeholder={"Enter subject name"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={1.5}>
                    <Label labelText={"Total"} required />
                    <TextInput
                      styleProps={globalStyle.textField}
                      placeholder={"Enter total marks"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={1.5}>
                    <Label labelText={"Passing"} required />
                    <TextInput
                      styleProps={globalStyle.textField}
                      placeholder={"Enter passing marks"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={2}>
                    <Label labelText={"Author"} required />
                    <TextInput
                      styleProps={globalStyle.textField}
                      placeholder={"Enter Author name"}
                    />
                  </Grid>
                </Grid>
              );
            })}
            <Typography
              variant="body1"
              color="primary.main"
              textAlign={"center"}
              my={2}
              onClick={() => handleAddNewSubject(mainIndex)}
            >
              Add New Subject
            </Typography>
          </Box>
        );
      })}

      <Stack alignItems={"flex-end"}>
        <GlobalButton
          btnText={"Add New Section"}
          handleClickBtn={handleAddNewSection}
          styleProps={{
            height: 45,
            width: "auto",
          }}
        />
      </Stack>
    </Stack>
  );
};

export default AddSections;
